import React, { useState } from "react";

import { Link } from "react-router-dom";

import { PageHeader, Button, Input, Divider } from "antd";
import { ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";

const { Search } = Input;

const BasicList = (props) => {
    const [textFilter, setTextFilter] = useState(props.textFilter);

    return (
        <PageHeader
            ghost={false}
            backIcon={props.onPressBack ? <ArrowLeftOutlined /> : false}
            onBack={props.onPressBack}
            title={props.titulo}
            subTitle={props.subtitulo ? props.subtitulo : "List"}
            extra={[
                props.onDownload && (
                    <Button key="download" type="default" onClick={props.onDownload}>
                        <DownloadOutlined /> <Divider type="vertical" /> Download
                    </Button>
                ),
                props.onSearchByText && (
                    <Search
                        key="search"
                        placeholder="search text"
                        onSearch={props.onSearchByText}
                        style={{ width: 200 }}
                        onChange={(e) => setTextFilter(e.target.value)}
                        value={textFilter}
                    />
                ),
                props.onPressNew && (
                    <Link key="new" to={props.onPressNew}>
                        <Button type="primary">New</Button>
                    </Link>
                ),
                props.onPressNewModal && (
                    <Button key="newModal" onClick={props.onPressNewModal} type="primary">
                        New
                    </Button>
                ),
            ]}
        >
            {props.children}
        </PageHeader>
    );
};

export default BasicList;
